const wowApp = require('angular').module('oly.common');

wowApp.directive('olyNumeric', [require('./numeric.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/numeric/index.js